import './BlurCard.css';
import React, { useEffect, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import bluePlusImg from '../../../resources/icons/blue-plus.svg';
import { ReactComponent as Padlock } from '../../../resources/icons/padlock-v2.svg';
import { isNil, isNotNil } from '../../../utils/IsNil';
import { canUseDOM, getGlobalDictionaryTerm, getMediaHost, injectImageResolution, pathJoin } from '../../../utils';
import { useSitecoreContext } from '../../../utils/hooks/UseSitecoreContext';
import { styled } from 'linaria/lib/react';
import { qsToObject } from '../../../utils/querystring';
import Reminder from '../../atoms/Reminder/Reminder';
var EBlurCardImageTypes = /*#__PURE__*/function (EBlurCardImageTypes) {
  EBlurCardImageTypes["event"] = "event";
  EBlurCardImageTypes["deals"] = "deals";
  return EBlurCardImageTypes;
}(EBlurCardImageTypes || {});
const isShowRuleIsHide = hint => (new Date(hint.showRuleShowStartDate).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0) || isNil(hint.showRuleShowStartDate) && hint.showRuleIsHide) && hint.showRuleIsHide;
const BlurCard = _ref => {
  let {
    hint,
    lang,
    cardType,
    hitAnalytics,
    hitParams,
    reminderTheme,
    countryItems,
    hitInSlider,
    showWithAnimation,
    isEventBlur,
    userProfile
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const [isMobile, setIsMobile] = useState(() => canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false);
  const ThisWillBeRevealedOn = getGlobalDictionaryTerm(sitecoreContext, 'ThisWillBeRevealedOn') || 'This will be revealed on';
  const injectImageWidthAndHeight = (width, height) => injectImageResolution(pathJoin([getMediaHost(), '']), width, height);

  /*   const reminderTheme: Array<String> = useMemo(() => {
  
      return [colorSettings['--component-background-color'], colorSettings['--component-color']];
  
    }, [colorSettings]) */

  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener("resize", () => {
        setIsMobile(window.matchMedia(`(max-width: 992)`).matches);
      });
    }
    return () => {
      if (canUseDOM) {
        window.addEventListener("resize", () => {
          setIsMobile(window.matchMedia(`(max-width: 992)`).matches);
        });
      }
    };
  }, []);
  const eventImage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: injectImageWidthAndHeight(340, 243)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageWidthAndHeight(340, 243)
  }));
  const dealsImage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: injectImageWidthAndHeight(580, 420)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageWidthAndHeight(325, 135)
  }));
  const mediaMap = {
    "event": eventImage,
    "deals": dealsImage
  };
  const defaultReturnValue = {
    padding: 0,
    cw: '',
    ch: '',
    isVerticalImage: false
  };
  const getImageSizes = children => {
    if (typeof window === 'undefined') return defaultReturnValue;
    return children.reduceRight((acc, child) => {
      const {
        src,
        srcSet,
        media
      } = child.props;
      const {
        cw,
        ch
      } = media ? qsToObject(srcSet) : qsToObject(src);
      if (!cw || !ch) return acc;
      const mq = media && window.matchMedia(media);
      if (media && (!mq || !mq.matches)) return acc;
      const padding = parseInt(ch) * 100 / parseInt(cw);
      const isVerticalImage = padding > 100;
      return {
        padding,
        cw,
        ch,
        isVerticalImage
      };
    }, defaultReturnValue);
  };
  const {
    padding,
    cw,
    ch,
    isVerticalImage
  } = getImageSizes(mediaMap[cardType].props.children);
  return /*#__PURE__*/React.createElement(CardStyledWrapper, {
    className: `${commonStyles}`,
    cardType: cardType
  }, /*#__PURE__*/React.createElement(ImageStyledWrapper, {
    className: "empty-placeholder blur-empty-placeholder",
    padding: padding,
    cw: cw,
    ch: ch,
    isVerticalImage: isVerticalImage,
    cardType: cardType
  }, /*#__PURE__*/React.createElement("div", {
    className: "hiddenImageContainer"
  }, /*#__PURE__*/React.createElement(Padlock, {
    className: "padlockIcon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "comingSoonText"
  }, ThisWillBeRevealedOn), isNotNil(hint.showRuleShowStartDate) ? /*#__PURE__*/React.createElement("span", {
    className: "comingSoonDate"
  }, new Intl.DateTimeFormat(lang, {
    month: 'long'
  }).format(new Date(hint.showRuleShowStartDate)), ' ', new Date(hint.showRuleShowStartDate).getDate()) : null)), /*#__PURE__*/React.createElement("div", {
    className: "blurBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerWrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "header cursorDefault"
  }, hint.title), /*#__PURE__*/React.createElement("button", {
    className: "headerBtn cursorDefault"
  }, /*#__PURE__*/React.createElement("img", {
    src: bluePlusImg,
    alt: "icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "blur-block__reminder"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    initiallyVisible: !showWithAnimation,
    animateIn: showWithAnimation ? 'animate__fadeInUp' : '',
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement(Reminder, {
    userProfile: userProfile,
    lang: lang,
    event: hint,
    countryItems: countryItems,
    themeValues: reminderTheme,
    modeSlider: hitInSlider,
    eventsAnalytics: hitAnalytics,
    params: hitParams,
    isEventBlur: isEventBlur
  }))));
};
const CardStyledWrapper = /*#__PURE__*/styled("div")({
  name: "CardStyledWrapper",
  class: "cs4qdsz",
  vars: {
    "cs4qdsz-0": [props => props.cardType === EBlurCardImageTypes.deals ? '0 3px 6px 0 rgba(0,0,0,0.16)' : 'none'],
    "cs4qdsz-1": [props => props.cardType === EBlurCardImageTypes.deals ? '5px' : '0']
  }
});
const ImageStyledWrapper = /*#__PURE__*/styled("div")({
  name: "ImageStyledWrapper",
  class: "i1514oa4",
  vars: {
    "i1514oa4-0": [props => props.isVerticalImage && props.cw ? '100%' : 'unset'],
    "i1514oa4-1": [props => props.isVerticalImage && props.ch ? '100%' : 'unset'],
    "i1514oa4-2": [props => props.isVerticalImage && props.cw ? `${props.cw}px` : 'unset'],
    "i1514oa4-3": [props => props.isVerticalImage && props.ch ? `${props.ch}px` : 'unset'],
    "i1514oa4-4": [props => `${props.padding}%`],
    "i1514oa4-5": [props => props.cardType === EBlurCardImageTypes.deals ? "10px" : "0"]
  }
});
const commonStyles = "cujt5fh";
export { BlurCard, isShowRuleIsHide, EBlurCardImageTypes };